import React from 'react';
import { useAppDispatch } from '../../../redux/hooks';
import { useUserSettingsSelector } from '../../../redux/selectorHooks';
import { setDefaultView } from '../../../redux/slices/userSettings';
import {
  DefaultView,
  defaultViewLabels,
  isDefaultViewMember,
} from '../../../utils/userSettings';
import { assertCondition } from '../../../utils/types';
import BuilderSelectMenu from '../../Builder/BuilderSelectMenu';

const options = Object.values(DefaultView).map((view) => ({
  value: view,
  text: defaultViewLabels[view],
}));

const DictionaryView = () => {
  const dispatch = useAppDispatch();
  const defaultView = useUserSettingsSelector('defaultView');

  const handleViewChange = (newView: string) => {
    assertCondition(isDefaultViewMember(newView));
    dispatch(setDefaultView(newView));
  };

  return (
    <BuilderSelectMenu
      options={options}
      value={defaultView}
      onChange={handleViewChange}
    />
  );
};

export default DictionaryView;
